module.exports = __webpack_public_path__ + "static/media/dribbble.25908753.svg";